import { UpdateSubjectRequest } from '@src/main/modules/messages/infrastructure/dto/updateSubjectRequest';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateSubjectUseCase = async (
  data: UpdateSubjectRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createSubjectHttpRepository(tokenProvider);
  return await repository.update(data);
};
